import { useAffiliateReferrerQuery } from "Api/Queries/Affiliate/useAffiliateReferrerQuery";
import type { AffiliateUserRole } from "Types/types";

/**
 * Who referred the caller for the role — the registration affiliate field locks on them.
 * Until it is known the field is not shown, so a person who came through a link never sees an
 * editable field flip to a locked one. A failed lookup leaves the field editable: the backend
 * still refuses a second affiliate.
 */
export const useAffiliateReferrer = (
  role: AffiliateUserRole,
  { isEnabled = true }: { isEnabled?: boolean } = {},
) => {
  const { data, isLoading, isError } = useAffiliateReferrerQuery(role, {
    isEnabled,
  });

  return {
    lockedReferrer: data?.hasReferrer ? data : null,
    isLoading,
    isError,
  };
};
